// extracted by mini-css-extract-plugin
export default {"create":"CreateADigitalDisplay_create__kOylg","createContent":"CreateADigitalDisplay_createContent__FvXJy"};